import { styledText } from '@/components/Typography/Typography.styles';
import styled from 'styled-components';
import RemoveIcon from '../../../../../../public/images/icons/close.svg';

export const TrackingInputWrapper = styled.div`
  display: block;
  width: 100%;
  max-height: 122px;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.colors.inactiveBlack};
  border-radius: ${({ theme }) => theme.spacing[4]};
  padding: ${({ theme }) => `0 ${theme.spacing[14]}`};
`;

export const Input = styled.input<{ isChipSection: boolean }>`
  all: unset;
  width: inherit;
  padding: ${({ isChipSection, theme }) => (isChipSection ? theme.spacing[8] : '10.5px')}
    0;
  ${styledText['Body Text Large']}
  &:placeholder-shown {
    text-overflow: ellipsis !important;
  }
`;

export const ChipsContainer = styled.span`
  display: block;
  padding: ${({ theme }) => `${theme.spacing[8]} 0 0 0`};
`;

export const ChipWrapper = styled.span`
  display: inline-block;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.colors.surface03};
  padding: ${({ theme }) => `2px ${theme.spacing[12]}`};
  margin: ${({ theme }) => `0 ${theme.spacing[8]} ${theme.spacing[8]} 0`};
  width: fit-content;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    :hover {
      background-color: ${({ theme }) => theme.colors.surface04};
    }
  }
`;

export const ChipDetail = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  ${styledText['Body Text Large']}
`;

export const RemoveButton = styled(RemoveIcon)`
  margin-left: ${({ theme }) => theme.spacing[8]};
  width: 18px;
  height: 18px;
  cursor: pointer;

  & > path {
    fill: ${({ theme }) => theme.colors.highEmphasisBlack};
    fill-opacity: 1;
  }
`;
